export default "__VITE_ASSET__UZCE7kA0__"